module.exports = __webpack_public_path__ + "img/9788971995891.bda93e03.jpg";